import { useQuery } from "@tanstack/react-query";

import type { components } from "@/api/types";
import { apiGet, qk } from "@/shared/api";

export type RatingMode = components["schemas"]["RatingMode"];
export type RatingPeriod = components["schemas"]["RatingPeriod"];
export type RatingEntry = components["schemas"]["RatingEntry"];

/**
 * Рейтинг участников.
 *
 * Режим и период уходят в запрос, а не режут список на клиенте: ранжирование
 * — это сортировка по всей базе, и «показать первых десять за неделю» нельзя
 * получить фильтрацией десяти строк, пришедших за день.
 *
 * `placeholderData` держит предыдущую выборку на время переключения: без него
 * подиум схлопывается в скелетон на каждое нажатие таба, и экран мигает.
 */
export function useRating(mode: RatingMode, period: RatingPeriod) {
  return useQuery({
    queryKey: qk.rating(mode, period),
    queryFn: ({ signal }) =>
      apiGet("/api/v1/rating", { query: { mode, period }, signal }),
    placeholderData: (previous) => previous,
  });
}
